const key = "INDIVIDUAL_OPTIONS"

export const INDIVIDUAL_OPTIONS = {
        SET_FIELDS: `${key}_SET_FIELDS`,
        CLEAR_FIELDS: `${key}_CLEAR_FIELDS`
};